import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, } from 'lucide-react';
import { Button, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, } from '@cargomatic/ui';
export function TablePagination({ page, pages, total, perPage, onPageChange, selectedCount, pageSizeOptions, onPageSizeChange, }) {
    const startRow = (page - 1) * perPage + 1;
    const endRow = Math.min(page * perPage, total);
    const canPrevious = page > 1;
    const canNext = page < pages;
    return (React.createElement("div", { className: "flex items-center justify-between px-2 py-4" },
        React.createElement("div", { className: "flex-1 text-sm text-muted-foreground" }, selectedCount != null ? (React.createElement("span", null,
            selectedCount,
            " of ",
            total,
            " row(s) selected.")) : total === 0 ? (React.createElement("span", null, "No results")) : (React.createElement("span", null,
            "Showing ",
            startRow,
            " to ",
            endRow,
            " of ",
            total,
            " results"))),
        React.createElement("div", { className: "flex items-center space-x-6 lg:space-x-8" },
            pageSizeOptions && onPageSizeChange && (React.createElement("div", { className: "flex items-center space-x-2" },
                React.createElement("p", { className: "text-sm font-medium" }, "Rows per page"),
                React.createElement(Select, { value: `${perPage}`, onValueChange: (value) => onPageSizeChange(Number(value)) },
                    React.createElement(SelectTrigger, { className: "h-8 w-[70px]", "aria-label": "Rows per page" },
                        React.createElement(SelectValue, { placeholder: `${perPage}` })),
                    React.createElement(SelectContent, { side: "top" }, pageSizeOptions.map((size) => (React.createElement(SelectItem, { key: size, value: `${size}` }, size))))))),
            React.createElement("div", { className: "flex w-[100px] items-center justify-center text-sm font-medium" },
                "Page ",
                page,
                " of ",
                pages),
            React.createElement("div", { className: "flex items-center space-x-2" },
                React.createElement(Button, { variant: "outline", className: "hidden h-8 w-8 p-0 lg:flex", onClick: () => onPageChange(1), disabled: !canPrevious, "aria-label": "Go to first page" },
                    React.createElement(ChevronsLeft, { className: "h-4 w-4" })),
                React.createElement(Button, { variant: "outline", className: "h-8 w-8 p-0", onClick: () => onPageChange(page - 1), disabled: !canPrevious, "aria-label": "Go to previous page" },
                    React.createElement(ChevronLeft, { className: "h-4 w-4" })),
                React.createElement(Button, { variant: "outline", className: "h-8 w-8 p-0", onClick: () => onPageChange(page + 1), disabled: !canNext, "aria-label": "Go to next page" },
                    React.createElement(ChevronRight, { className: "h-4 w-4" })),
                React.createElement(Button, { variant: "outline", className: "hidden h-8 w-8 p-0 lg:flex", onClick: () => onPageChange(pages), disabled: !canNext, "aria-label": "Go to last page" },
                    React.createElement(ChevronsRight, { className: "h-4 w-4" }))))));
}
